<template>
  <transition name="ws-banner-fade">
    <div v-if="visible" class="ws-banner">
      <span class="ws-banner__dot" />
      <span class="ws-banner__text">Connexion au serveur perdue — reconnexion automatique en cours…</span>
      <a-button size="small" type="primary" :loading="reconnecting" @click="onReconnect">
        Reconnecter
      </a-button>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import { wsConnectionStatus, reconnectSocket } from '/@/websocket/connection-status'

// On n'affiche la bannière que si un socket s'est déjà connecté puis a été coupé
// (évite de clignoter pendant la toute première connexion).
const visible = computed(() =>
  wsConnectionStatus.active && wsConnectionStatus.everConnected && !wsConnectionStatus.connected
)

const reconnecting = ref(false)

function onReconnect () {
  reconnecting.value = true
  reconnectSocket()
}

// Dès que la connexion revient, on arrête l'état « en cours de reconnexion ».
watch(
  () => wsConnectionStatus.connected,
  connected => {
    if (connected) reconnecting.value = false
  }
)
</script>

<style lang="scss" scoped>
.ws-banner {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border-radius: 6px;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  color: #cf1322;
  font-size: 14px;

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #cf1322;
    animation: ws-banner-blink 1s ease-in-out infinite;
  }

  &__text {
    white-space: nowrap;
  }
}

@keyframes ws-banner-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

.ws-banner-fade-enter-active,
.ws-banner-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.ws-banner-fade-enter-from,
.ws-banner-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -8px);
}
</style>
